import { LitElement, html, css } from 'lit';
import { navFilter } from '../../utilities/navUtilities';
import { navIcons } from '../../utilities/icons';
import { arrow, web, address } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
import { grid, sidebar } from '../../utilities/styles';
export class AllInNavigation extends LitElement {
    static properties = {
        type: { type: String },
        header: { type: String },
        navigation: { type: Array, converter: navFilter },
        currentPage: { type: String },
        mobile: { type: Boolean },
        name: { type: String },
        sidebar: { type: String },
        _initialNavigation: { state: true, type: Array },
    };
    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this._initialNavigation = [...this.navigation];
        this.eventManager.listen(`allin-navigation-${this.name}`, this._handleNavChange);
        this.callbacks = {};
    }
    /* firstUpdated(){
    } */
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    _handleNavChange(e) {
        if (e.detail.navigation) {
            if (e.detail.initial) {
                this._initialNavigation = [...e.detail.navigation];
            }
            if (e.detail.navigation == 'reset') {
                this.navigation = this._formatNavigation([...this._initialNavigation]);
                this.currentPage = e.detail.currentPage;
            }
            else {
                this.navigation = this._formatNavigation(e.detail.navigation);
                this.currentPage = e.detail.currentPage;
            }
        }
        else {
            this.currentPage = e.detail;
        }
        if (e.detail.sidebar) {
            this.sidebar = e.detail.sidebar;
            // Save onlineEventLink only when sidebar exists
            this._onlineEventLink = e.detail.onlineEventLink || null;
            this._touringEventLocation = e.detail.touringEventLocation || null;
        }
        else {
            this.sidebar = '';
            this._onlineEventLink = null;
            this._touringEventLocation = null;
        }
        /*  this.requestUpdate();
         if(!this._isLoaded){
             console.log('delayed update');
             setTimeout(() => {
                 console.log('???');
                 this.requestUpdate();
             }, 3000);
         } */
    }
    _handleSelect(e) {
        this.callbacks[e.target.selectedOptions[0].dataset.callback]?.(e);
        window.location.href = e.target.value;
    }
    //New functions to format nav item sentence case
    _formatNavTitle(title) {
        if (!title)
            return '';
        let formatted = title.toLowerCase();
        formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
        if (formatted.includes('accessibility standards')) {
            return 'All In Accessibility Standards';
        }
        if (formatted.includes('standards')) {
            return 'Standards';
        }
        if (formatted.includes('apis')) {
            formatted = formatted.replace('apis', 'APIs');
        }
        return formatted;
    }
    _formatNavigation(navigation) {
        if (!Array.isArray(navigation))
            return navigation;
        return navigation.map((group, groupIndex) => group
            .map((item, itemIndex) => ({
            ...item,
            title: item.noTransform ? item.title : this._formatNavTitle(item.title)
        })));
    }
    render() {
        let icon = navIcons[this.type] ?? '';
        if (this.mobile) {
            return html `\n                <h2 class="h3-before"><span aria-hidden="true" id="page_sub_nav">${icon}</span>${this.header}</h2>\n                <select aria-labelledby="page_sub_nav" @change=${this._handleSelect}>\n                <option value="">Select an option</option>\n                ${this.navigation.map((item) => {
                if (!item)
                    return;
                return html `\n                        ${item.map((subItem) => {
                    let current = '';
                    let id = subItem.id ? subItem.id : subItem.url.replaceAll('/', '');
                    if (id == this.currentPage.replaceAll('/', '')) {
                        current = 'current';
                    }
                    if (!subItem.hasOwnProperty('callback')) {
                        subItem.callback = (e) => {
                            return true;
                        };
                    }
                    this.callbacks[id] = subItem.callback;
                    return html `\n                            <option value="${subItem.url}" ${current ? 'selected' : ''} data-callback=${id}>${subItem.title}</option>\n                        `;
                })}\n                    \n                    `;
            })}\n                </select>\n                `;
        }
        else {
            let nav = this.navigation.length ? html ` \n                <nav class="${this.type}">\n                    <h2 class="h3-before"><span aria-hidden="true">${icon}</span>${this.header}</h2>\n                    ${this.navigation.map((item) => {
                if (!item)
                    return;
                return html `\n                        <ul>\n                            ${item.map((subItem) => {
                    let current = '';
                    let aria = 'false';
                    let id = subItem.id ? subItem.id : subItem.url.replaceAll('/', '');
                    if (id == this.currentPage.replaceAll('/', '')) {
                        current = 'current';
                        aria = 'page';
                    }
                    if (!subItem.hasOwnProperty('callback')) {
                        subItem.callback = (e) => {
                            return true;
                        };
                    }
                    let indent = subItem.indent ? 'indent' : '';
                    return html `\n                                <li class="${current} ${indent}" aria-current="${aria}">\n                                    <a href="${subItem.url}" @click=${subItem.callback}><span aria-hidden="true">${subItem.icon ? navIcons[subItem.icon] : ''}</span>${subItem.title}</a>\n                                </li>\n                                `;
                })}\n                        </ul>\n                        `;
            })}\n                </nav>\n                ` : '';
            let sidebar = this.sidebar ? html `\n                    <div class="sidebar">\n                        ${this.sidebar}\n                        ${this._onlineEventLink ? html `\n                            <div class="item grid grid--icon">\n                                <div class="icon">${web}</div>\n                                <div class="text">\n                                    <p><strong>Relevant access information:</strong></p>\n                                    <p>\n                                        <a href="${this._onlineEventLink.url}" target="${this._onlineEventLink.target}" rel="noopener">\n                                            ${this._onlineEventLink.url}\n                                        </a>\n                                    </p>\n                                </div>\n                            </div>\n                        ` : ''}\n                    </div>\n                ` : '';
            return html `\n                ${nav}\n                ${sidebar}\n                `;
        }
    }
    static styles = [
        grid,
        sidebar,
        css `
            :host {
                font-family:var(--allin-font-family,inherit);
                font-size:var(--allin-font-size,1rem);
                color:var(--allin-text-color,#472961);
                background-color:var(--allin-bg-color,transparent);
                padding:var(--allin-padding,0);
            }
            nav h2.h3-before{
                 display: flex;
                align-items: center;
                gap: 1rem;
                margin: 0 0 calc(1rem - 7px) 0;
                font-size: 1.17em;
            }
            nav h3{
                display:flex;
                align-items:center;
                gap:1rem;
                margin:0 0 1rem 0;
            }
            nav h3 span, li a span{
                display:flex;
                align-items:center;
                justify-content:center;
            }
            ul{
                list-style:none;
                margin:0;
                padding:0;
                border-top:1px solid var(--allin-border-color,#707070);
            }
            ul:last-child{
                border-bottom:1px solid var(--allin-border-color,#707070);
            }
            .icon_text ul{
                border:none;
            }
            li{
                padding:0.75rem 1rem 0.75rem 0.5rem;
            }
            .grid.grid--icon li{
                padding:0.75rem 1rem 0.75rem 0rem;
            }
            ul li:not(:first-child) {
                padding-left: 2rem;
            }
            .account ul li:not(:first-child) {
                padding-left: 0.5rem;
            }

            ul li.indent, .account ul li.indent {
                padding-left: 4rem;
            }
            ul li a:has(> span > svg) {
                padding-left: 2rem;
            }
            li a{
                display:grid;
                grid-template-columns:1.5rem auto;
                align-items:center;
                font-weight:700;
                text-decoration:none;
                transition:color var(--transition) ease;
                color:var(--allin-text-color,#472961);
                gap:0.75rem;
            }
            .icon_text li a{
                display:inline;
            }
            li a:hover{
                color:var(--allin-hover-color,#8141B9);
            }
            li.current{
                background-color:var(--allin-current-color,#D3C9D7);
            }
            @media (forced-colors: active) {
                li.current{
                    border: 1px solid;
                    margin: 3px 0;
                }
            }
            select{
                margin-bottom:2rem;
                font-family:var(--allin-font-family,'Montserrat');
                font-size:1rem;
                padding:0.5rem;
            }
            .margin-bottom{
                margin-bottom:1rem;
            }
            
        `
    ];
}
